/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import { ForgotPassword } from "./components/ForgotPassword";
import { Login } from "./components/Login";
import { toAbsoluteUrl } from "../../../_metronic/helpers";
import { ResetPassword } from "./components/ResetPassword";
import { useIntl } from "react-intl";
import { isFornitoriMode, isItaltexMode } from "../../utils/version";

const AuthLayout = () => {
  const intl = useIntl();
  useEffect(() => {
    document.body.classList.add("bg-white");
    return () => {
      document.body.classList.remove("bg-white");
    };
  }, []);

  return (
    <div className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed">
      {/* begin::Content */}
      <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
        {/* begin::Logo */}
        <div className="mb-12">
          <img
            alt="Logo"
            src={toAbsoluteUrl("/media/logos/logo-integro.png")}
            className="h-100px"
          />
        </div>
        {isFornitoriMode() && (
          <h2 className="mb-4">
            {intl.formatMessage({ id: "menu.providers" })}
          </h2>
        )}

        {isItaltexMode() && (
          <h2 className="mb-4">
            {intl.formatMessage({ id: "menu.italtex_mode" })}
          </h2>
        )}

        {/* end::Logo */}
        {/* begin::Wrapper */}
        <div className="w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto">
          <Outlet />
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}
      {/* begin::Footer */}
      <div className="d-flex flex-center flex-column-auto p-10">
        <div className="d-flex align-items-center fw-bold fs-6">
          <a
            href={`mailto:${process.env.REACT_APP_COMPANY_MAIL_CONTACT}`}
            className="text-muted text-hover-primary px-2"
          >
            {intl.formatMessage({ id: "common.contact" })}
          </a>
        </div>
        {process.env.REACT_APP_GIT_VERSION && (
          <div>
            <small className="gx-ml-1 gx-text-grey">
              &nbsp;- v{process.env.REACT_APP_GIT_VERSION.substring(0, 7)}
              &nbsp;
            </small>
          </div>
        )}
      </div>

      {/* end::Footer */}
    </div>
  );
};

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path="login" element={<Login />} />

      <Route path="reset-password/" element={<ResetPassword />} />
      <Route path="reset-password/:token/:email" element={<ResetPassword />} />

      <Route path="forgot-password" element={<ForgotPassword />} />
      <Route index element={<Login />} />
      <Route path="*" element={<Login />} />
    </Route>
  </Routes>
);

export { AuthPage };
